import React from 'react';
import { FileCheck, CheckCircle, Clock, Shield } from 'lucide-react';
import CTASection from '../../components/CTASection';

const StatementOfUsePage = () => {
  return (
    <div>
      <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-block bg-[#168356]/20 text-[#168356] px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Statement of Use Services
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              <span className="text-[#168356]">Statement of Use</span> Filing & Extensions
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Complete your trademark registration by filing your Statement of Use. We handle specimens, forms, and all USPTO requirements.
            </p>
            <div className="flex gap-4">
              <button className="bg-[#d29b00] hover:bg-[#a87b00] text-white font-bold px-8 py-4 rounded-lg transition-all">
                File Your SOU Now
              </button>
            </div>
            <div className="flex items-center gap-6 mt-8 text-sm">
              <span className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-[#168356]" />
                92% Approval Rate
              </span>
              <span className="flex items-center gap-2">
                <Clock className="w-5 h-5 text-[#168356]" />
                3-5 Day Turnaround
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">What is a Statement of Use?</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              The final step to complete your Intent-to-Use trademark registration
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 rounded-xl p-8">
              <FileCheck className="w-12 h-12 text-[#168356] mb-4" />
              <h3 className="text-xl font-bold text-black mb-3">Complete Registration</h3>
              <p className="text-gray-700">
                Convert your Intent-to-Use application to full registration by proving actual use in commerce.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl p-8">
              <Shield className="w-12 h-12 text-[#168356] mb-4" />
              <h3 className="text-xl font-bold text-black mb-3">Preserve Priority Date</h3>
              <p className="text-gray-700">
                Maintain your original filing date for trademark priority and protection against later filers.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl p-8">
              <CheckCircle className="w-12 h-12 text-[#168356] mb-4" />
              <h3 className="text-xl font-bold text-black mb-3">Expert Preparation</h3>
              <p className="text-gray-700">
                We handle all specimens, forms, and USPTO requirements for high approval rates.
              </p>
            </div>
          </div>
        </div>
      </div>

      <CTASection />
    </div>
  );
};

export default StatementOfUsePage;
